import React from "react"
import Slider from "react-slick"
import { Typography, Grid } from "@mui/material"
import { Add, Close, KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material"
import styles from "./ItemsSlider.module.scss"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import imagePlaceHolder from "assets/images/imagePlaceholder.png"

const SLIDES_TO_SHOW = 5

const PrevArrow = (props) => {
  const { onClick } = props
  return (
    <div className={`${styles.arrowBtn} ${styles.prev}`} onClick={onClick}>
      <KeyboardArrowLeft />
    </div>
  )
}

const NextArrow = (props) => {
  const { onClick } = props
  return (
    <div className={`${styles.arrowBtn} ${styles.next}`} onClick={onClick}>
      <KeyboardArrowRight />
    </div>
  )
}

const ItemsSlider = ({
  items: itemsProp,
  onAdd,
  onRemove,
  readOnly = false,
  layout = "slider"
}) => {
  const items = Array.isArray(itemsProp) ? itemsProp : []
  const totalCards = readOnly ? items.length : items.length + 1
  const needsSlider = totalCards > SLIDES_TO_SHOW

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    slidesToShow: SLIDES_TO_SHOW,
    slidesToScroll: 1,
    swipeToSlide: true,
    draggable: true,
    touchMove: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 4, slidesToScroll: 1 }
      },
      {
        breakpoint: 900,
        settings: { slidesToShow: 3, slidesToScroll: 1 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2, slidesToScroll: 1 }
      }
    ]
  }

  const renderItem = (item, idx) => (
    <div
      key={item.id || idx}
      className={`${styles.featureItemContainer} ${needsSlider ? styles.sliderCard : ""}`}>
      {!readOnly && !item.isFallback && (
        <div className={styles.actionButtons}>
          <div className={styles.removeBtn} onClick={() => onRemove(item.id, item)}>
            <Close />
          </div>
        </div>
      )}
      <img
        src={item.image || item?.image_url || imagePlaceHolder}
        className={styles.itemImage}
        alt={item.name}
      />
      <div className={styles.itemDetail}>
        <Typography className={styles.itemName}>{item.name}</Typography>
        <Typography className={styles.itemCategory}>{item.category || item.time}</Typography>
      </div>
    </div>
  )

  const renderAddButton = () => (
    <div
      className={`${styles.addItemContainer} ${needsSlider ? styles.sliderCard : ""}`}
      onClick={onAdd}>
      <div className={styles.addIconCircle}>
        <Add />
      </div>
      <button className={styles.addItemBtn}>Add Items</button>
    </div>
  )

  if (layout === "grid") {
    return (
      <Grid container spacing={2} style={{ marginTop: "16px" }}>
        {!readOnly && (
          <Grid item xs={12} sm={6} md={4}>
            {renderAddButton()}
          </Grid>
        )}
        {items?.map((item, idx) => (
          <Grid item xs={12} sm={6} md={4} key={item.id || idx}>
            {renderItem(item, idx)}
          </Grid>
        ))}
      </Grid>
    )
  }

  if (!needsSlider) {
    return (
      <div className={styles.flexContainer}>
        {!readOnly && renderAddButton()}
        {items?.map((item, idx) => renderItem(item, idx))}
      </div>
    )
  }

  const sliderKey = items.map((i) => i.id).join("-") || "empty"

  return (
    <div className={styles.sliderWrapper} style={{ marginTop: "16px" }}>
      <Slider key={sliderKey} {...settings}>
        {!readOnly && <div className={styles.slidePadding}>{renderAddButton()}</div>}
        {items?.map((item, idx) => (
          <div key={item.id || idx} className={styles.slidePadding}>
            {renderItem(item, idx)}
          </div>
        ))}
      </Slider>
    </div>
  )
}

export default ItemsSlider
